import api from '@/api'

export default {
  namespaced: true,
  state: () => ({
    items: [],
    isLoading: false,
    pagination: { currentPage: 1, perPage: 10, total: 0, lastPage: 1, from: 0, to: 0 },
    search: ''
  }),
  mutations: {
    SET_ITEMS(s, v){ s.items = v || [] },
    SET_LOADING(s, v){ s.isLoading = v },
    SET_PAGINATION(s, v){ s.pagination = { ...s.pagination, ...v } },
    SET_SEARCH(s, v){ s.search = v || '' },
  },
  actions: {
    async fetch({ commit, state }, page = 1) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/areas', {
          params: { page, per_page: state.pagination.perPage, search: state.search }
        })
        commit('SET_ITEMS', data?.data || [])
        const m = data?.meta || {}
        commit('SET_PAGINATION', {
          currentPage: m.current_page ?? page,
          perPage: m.per_page ?? state.pagination.perPage,
          total: m.total ?? (data?.data?.length || 0),
          lastPage: m.last_page ?? 1,
          from: m.from ?? 0,
          to: m.to ?? (data?.data?.length || 0)
        })
      } finally { commit('SET_LOADING', false) }
    },
    async create(_, payload){ return api.post('/areas', payload) },
    async update(_, { id, payload }){ return api.put(`/areas/${id}`, payload) },
    async delete(_, id){ return api.delete(`/areas/${id}`) },
  },
  getters: {
    items: s => s.items,
    isLoading: s => s.isLoading,
    pagination: s => s.pagination,
    search: s => s.search
  }
}
